import api from 'clients/api/Api';

export type AccessStatus = 'Active' | 'Pending' | 'Revoked';
export interface FranchiseAccessUser {
  userId: string;
  subject: string;
  name: string;
  email: string;
  status: AccessStatus;
  franchiseId?: string;
  franchiseName?: string;
  version: string;
}
export interface AccessHistoryItem {
  createdAt: string;
  actor: string;
  previousStatus: AccessStatus;
  status: AccessStatus;
  previousFranchiseId?: string;
  franchiseId?: string;
  reason: string;
}
const base = 'cardio/FranchiseAccess';
export const FranchiseAccessService = {
  list: async (page: number, search: string, status: string) => {
    const { data } = await api.get<{ data: { users: FranchiseAccessUser[]; total: number } }>(
      base,
      { params: { page, size: 20, search, status: status || undefined } },
    );
    return data.data;
  },
  change: async (
    user: FranchiseAccessUser,
    revoke: boolean,
    reason: string,
    franchiseId?: string,
  ) => {
    await api.post(`${base}/${user.userId}/${revoke ? 'Revoke' : 'Grant'}`, {
      version: user.version,
      reason,
      franchiseId: revoke ? undefined : franchiseId,
    });
  },
  history: async (userId: string, page: number) => {
    const { data } = await api.get<{ data: { items: AccessHistoryItem[]; total: number } }>(
      `${base}/${userId}/History`,
      { params: { page } },
    );
    return data.data;
  },
};
